/**
 * The main JavaScript file for the Wisesite Team plugin.
 */



/**
 * Module imports.
 */

import { Team } from "./modules/team/team.js";


/**
 * Runtime.
 */

// Set a global variable to handle our app data
if ( typeof window.app === 'undefined' )
{
	window.app = {};
}

if ( typeof window.app.init === 'undefined' )
{
	window.app.init = {};
}

// Define all the functions we want to run on initiation but don't actually run them as this is donw in the child theme
window.app.init.wisesiteTeam =
{
	'team' : Team.addListeners,
};



// WEBPACK FOOTER //
// ../wp-content/plugins/wisesite-team/assets/js/main.js